import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { setCurrentOrganization } from '../../actions/organization'
import { P2 } from '../styled/typography/typography'

export default class Organization extends Component {
  render() {
    const { organization, disabled } = this.props
    const onClickBound = this.onClick.bind(this)
    const roles = this.getOrganizationRoles()
    this.isMentor = roles.includes("qa_mentor")

    let orgInitials = organization.name.match(/\b(\w)/g).join('')
    orgInitials =
      orgInitials.length > 2 ? orgInitials.substr(0, 2) : orgInitials
    const tooltipId = Math.floor(Math.random() * 1000000) + 1

    return (
      <li
        className={`organization ${disabled ? 'disabled' : ''}`}
        onClick={onClickBound}
        data-tip="Complete your recording before changing organizations"
        data-for="disallow-leaving-org-tooltip"
      >
        <div className='rule'/>
        <div className="avatar" data-tip="Mentor" data-for={`${tooltipId}`}>
          <div className="org-photo-wrapper">
            {organization.photo ? (
              <img src={organization.photo} alt={'organization photo'} />
            ) : (
              <div className="placeholder-container">
                <div className="placeholder">{orgInitials}</div>
              </div>
            )}

            {this.isMentor && (
              <Fragment>
                <div
                  className='mentor'
                  style={{ borderWidth: '0 0 15px 15px' }}
                />
                {!disabled && (
                  <ReactTooltip id={`${tooltipId}`} effect="solid" />
                )}
              </Fragment>
            )}
          </div>
        </div>
        <div className="org-info">
          <P2 className="name">{organization.name}</P2>
        </div>
      </li>
    )
  }

  onClick() {
    const { dispatch, organization, disabled } = this.props
    if (!disabled) {
      dispatch(setCurrentOrganization(organization.id, this.isMentor, true))
    }
  }

  getOrganizationRoles() {
    const { organization, user } = this.props
    const org = user.organizations.find(function (org) {
      return org.id === organization.id
    })

    return org.roles
  }
}

Organization.propTypes = {
  dispatch: PropTypes.func,
  organization: PropTypes.object,
  user: PropTypes.object
}
